<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('attendanceDevice.deviceIpId')
          }}</label>
          <input
            v-model.trim="model.device_ip"
            type="text"
            class="form-control"
          />
          <div class="validate" v-if="errors.has('device_ip')">
            {{ errors.first('device_ip') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required ts-text-xs mt-2">{{
            $t('attendanceDevice.type')
          }}</label>
          <a-select
            v-model.number="model.device_type_id"
            style="width:100%"
            :options="att_type_list"
          ></a-select>
          <div class="validate" v-if="errors.has('device_type_id')">
            {{ errors.first('device_type_id') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required ts-text-xs mt-2">{{
            $t('attendanceDevice.description')
          }}</label>
          <textarea
            v-model.trim="model.device_description"
            rows="3"
            class="form-control"
          ></textarea>
          <div class="validate" v-if="errors.has('device_description')">
            {{ errors.first('device_description') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mt-2">
          <ts-checkbox v-model="model.device_active">{{
            $t('attendanceDevice.active')
          }}</ts-checkbox>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12 text-right">
          <slot name="action-button"></slot>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'attendanceDeviceTypeForm',
  props: ['value', 'validate'],
  data() {
    return {
      loading: false,
      att_type_list: [],
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.getAttendanceType()
    this.model = this.value
  },
  methods: {
    getAttendanceType() {
      this.loading = true
      this.$store
        .dispatch('attendanceDevice/getAttendanceType')
        .then(response => {
          this.att_type_list = response.data.map(el => ({
            value: el.device_type_id,
            label: el.device_type
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
